import Args from "~/components/Args/Args";
import AccessibilityTable from "~/components/AccessibilityTable/AccessibilityTable";
import ComponentStatusBar from "~/components/ComponentStatusBar/ComponentStatusBar";
import ComponentDescription from "~/components/ComponentDescription/ComponentDescription";
import ComponentImages from "~/components/ComponentImages/ComponentImages";
import * as React from 'react';
export default {
  Args,
  AccessibilityTable,
  ComponentStatusBar,
  ComponentDescription,
  ComponentImages,
  React
};